import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import config from '../../function/config';
import axios from 'axios';
import Logo from "../video/Mariniz Logo Gold.png";
import Basic from './PlansImage/BasicPack.jpg'
import Premium from './PlansImage/PremiumPack.jpg'
import PlatinumPack from './PlansImage/PlatinumPack.jpg'

export default function UserMyListing() {

   const token = localStorage.getItem('token')
    const [email, setEmail] = useState('')
     const [Phone, setPhone] = useState('')
     const [image, setImage] = useState('')
     const [ci, setCi] = useState('')  // Holds the current image URL
     const [loading, setLoading] = useState(false)
       const [username, setusername] = useState('')
       const [UserID, setUserID] = useState(null)

       const [type,setType] = useState('sale')
     
   const navigate = useNavigate('')
   
     const { id } = useParams()
   const [myShips, setMyShips] = useState([]);
   const [myCharters,setMyCharters] = useState([])

    useEffect(() => {
  async function fetchdata() {
    try {
      const res1 = await axios.get(
        `${config.base_url}/api/HappyMarineShipping/viewShipForCharter`,
        { headers: { "Content-Type": "multipart/form-data" } }
      )
      if (res1.data.status === 200 && UserID) {
        const sortedData = res1.data.data
          .filter(charter => charter.user === UserID) // ✅ only my charters
          .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        setMyCharters(sortedData)
      }
    } catch (error) {
      console.log(error)
    }
  }
  if (UserID) { // wait until UserID is set
    fetchdata()
  }
}, [UserID])
   

    useEffect(() => {
  async function fetchAll() {
    try {
      // Fetch user data
      const res2 = await axios.get(
        `${config.base_url}/api/HappyMarineShipping/alluser`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Token ${token}`,
          },
        }
      );
      console.log("API response:", res2.data);
      if (res2.data.Status === 200) {
        setusername(res2.data.user.username);
        setEmail(res2.data.user.email);
        setPhone(res2.data.user.phone);
        setUserID(res2.data.user.id);
        setCi(`${config.base_url}${res2.data.user.image}`);
      }

      // Fetch user's registered ships
      const shipRes = await axios.get(`${config.base_url}/api/HappyMarineShipping/viewShipForSale`, {
        headers: {
          'Authorization': `Token ${token}`
        }
      });

      if (shipRes.data.status === 200) {
        const sortedData = shipRes.data.data.filter(ship=>ship.user === res2.data.user.id).sort((a, b) => new Date(b.created_at) - new Date(a.created_at)); 
          setMyShips(sortedData)
      }

    } catch (error) {
      console.log("Error fetching user data or ships:", error);
    }
  }

  fetchAll();
}, [token]);

const [allImagesReg,setAllImagesReg] = useState([])
    
      useEffect(() => {
        async function fetchdata() {
          try {
            const res3 = await axios.get(
              `${config.base_url}/api/HappyMarineShipping/ship_images_Reg`,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                }
              }
            );
            if (res3.data.status === 200) {
              console.log("Images :",res3);
              setAllImagesReg(res3.data.data);
            } else {
              console.log("error");
            }
          } catch (error) {
            console.log(error);
          }
        }
        fetchdata();
      }, [config.base_url]);


        const [charterImg,setCharterImg] = useState([])
      
         useEffect(() => {
        async function fetchCharterImages() {
          try {
            const res3 = await axios.get(
              `${config.base_url}/api/HappyMarineShipping/ship_images_CReg`,
              { headers: { "Content-Type": "multipart/form-data" } }
            )
            console.log("Charter Images API:", res3.data) // 👈 Check the structure
            if (res3.data.status === 200 && Array.isArray(res3.data.data)) {
              setCharterImg(res3.data.data)
            } else {
              setCharterImg([]) // fallback
            }
          } catch (error) {
            console.log(error)
          }
        }
        fetchCharterImages()
      }, [])

      const [isSidebarOpen, setIsSidebarOpen] = useState(true);

        
      
        // Auto close sidebar when screen ≤ 950px
        useEffect(() => {
          const handleResize = () => {
            if (window.innerWidth <= 950) {
              setIsSidebarOpen(false);
            } else {
              setIsSidebarOpen(true);
            }
          };
      
          handleResize(); // Run once on mount
          window.addEventListener("resize", handleResize);
          return () => window.removeEventListener("resize", handleResize);
        }, []);
      
        const [isMobile, setIsMobile] = useState(window.innerWidth <= 950);
      
        useEffect(() => {
          const handleResize = () => {
            setIsMobile(window.innerWidth <= 950);
          };
          window.addEventListener("resize", handleResize);
          return () => window.removeEventListener("resize", handleResize);
        }, []);
      
        
      
        useEffect(() => {
          const handleResize = () => {
            if (window.innerWidth <= 950) {
              setIsSidebarOpen(false);
            } else {
              setIsSidebarOpen(true);
            }
          };
      
          // Run on mount
          handleResize();
      
          window.addEventListener("resize", handleResize);
          return () => window.removeEventListener("resize", handleResize);
        }, []);
      

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
const [activeTab, setActiveTab] = useState("ships"); // default

  const tabButtons = [
    { id: "ships", label: "Registered Ships" },
    { id: "charters", label: "Registered Charters" },
    { id: "logistics", label: "Registered Logistics" },
    { id: "equipments", label: "Registered Equipments" },
  ];
  const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 8;


// Calculate indexes for slicing
const indexOfLastShip = currentPage * itemsPerPage;
const indexOfFirstShip = indexOfLastShip - itemsPerPage;
const currentShips = myShips.slice(indexOfFirstShip, indexOfLastShip);
const currentCharters = myCharters.slice(indexOfFirstShip, indexOfLastShip);

const totalPages = Math.ceil(myShips.length / itemsPerPage);

useEffect(() => {
      if (!token) {
        navigate('/login'); // login page
      }
    }, [token, navigate]);
    
const handleLogout = () => {
  localStorage.removeItem("token"); // remove token
  navigate("/"); // redirect to login page
};
   
  return (
    <div className="flex h-screen transition-all duration-300 ease-in-out">
      {/* Sidebar */}
      <div
        className={`bg-[#253356] text-white h-[100vh] overflow-hidden transition-all duration-300 ease-in-out ${
          isSidebarOpen
            ? isMobile
              ? "w-full" // full width on small screens
              : "w-60" // 60px on larger screens
            : "w-0"
        }`}
      >
        <div className=' p-5'>
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-xl font-bold">Mariniz</h2>
            <button
              onClick={toggleSidebar}
              className="text-2xl focus:outline-none"
            >
              <i className="fa-solid fa-bars"></i>
            </button>
          </div>
  
          <div className='py-3  mt-2'>
               <img
        className="w-[80px]  h-[80px]  rounded-full"
        src={ci}
        alt=""
      />
          </div>
  
          <ul className="space-y-4 mt-3">
            <li onClick={()=>navigate('/userHome')} className="hover:bg-[#d1a460] hover:transition-all hover:scale-105 hover:duration-300 p-2 hover:rounded-r-full hover:shadow-lg hover:font-semibold hover:text-[#253356]  cursor-pointer">Home</li>
            
            <li onClick={()=>navigate('/userDashboard')} className=" hover:bg-[#d1a460] hover:transition-all hover:scale-105 hover:duration-300 p-2 hover:font-semibold  hover:rounded-r-full hover:shadow-lg hover:text-[#253356] cursor-pointer">Dashboard</li>
            <li onClick={()=>navigate('/userlist')} className="bg-[#d1a460] p-2 rounded-r-full shadow-lg font-semibold text-[#253356]  cursor-pointer">My Listing</li>
   
            <li onClick={()=>navigate('/userprofile')} className="hover:bg-[#d1a460] hover:transition-all hover:scale-105 hover:duration-300 p-2 hover:rounded-r-full hover:shadow-lg hover:font-semibold hover:text-[#253356]  cursor-pointer">Profile</li>
  
            
  
            <li onClick={handleLogout} className="hover:bg-[#d1a460] hover:transition-all hover:scale-105 hover:duration-300 p-2 hover:rounded-r-full hover:shadow-lg hover:font-semibold hover:text-[#253356]  cursor-pointer">Logout</li>
          </ul>
        </div>

      </div>

      {/* Main Content */}
      <div
        className={`transition-all duration-300  ease-in-out overflow-y-auto flex-1 px-5 py-2 bg-gray-100 ${
          isSidebarOpen ? "ml-0" : "w-full"
        }`}
      >
        <div className="flex items-center justify-between mb-6">
          {/* Optional second toggle button here if sidebar is closed */}
          {!isSidebarOpen && (
            <button
              onClick={toggleSidebar}
              className="text-2xl text-gray-600 focus:outline-none"
            >
              <i className="fa-solid fa-bars"></i>
            </button>
          )}
          
        </div>

        <div className="bg-white p-5 flex justify-between  rounded-lg text-[#253356] font-semibold shadow">
          <p className='text-3xl xm:text-xl'>My <span className='text-[#d1a460] font-bold italic'>Listings</span></p>
                      <button onClick={()=>navigate('/regShip')} className='bg-[#253356] rounded-lg p-2 text-white'>New Listing +</button>

        </div>
        <div className='mt-6  p-5'>
            <div className="mb-10">
      {/* Buttons for sm+ screens */}
      <div className="sm:hidden flex justify-center flex-wrap gap-6">
        {tabButtons.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`text-lg 2xl:text-sm px-5 py-2 rounded-lg font-semibold transition-colors duration-200
              ${
                activeTab === tab.id
                  ? "bg-[#d1a460] text-white shadow-md scale-105"
                  : "bg-[#253356] text-[#d1a460] hover:bg-[#35446d] hover:scale-105"
              }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Select dropdown for xs screens */}
      <div className="hidden sm:flex justify-center">
        <select
          value={activeTab}
          onChange={(e) => setActiveTab(e.target.value)}
          className="px-4 py-2 w-[100%] rounded-lg font-semibold bg-[#253356] text-[#d1a460] shadow-md"
        >
          {tabButtons.map((tab) => (
            <option key={tab.id} value={tab.id}>
              {tab.label}
            </option>
          ))}
        </select>
      </div>
    </div>
         {/* Tab Content */}
      {activeTab === "ships" && (
  <div className="mt-14 text-[#253356]">
    {myShips.length > 0 ? (
      <>
        <div className="grid grid-cols-4 2xl:flex ssm:flex-wrap ssm:justify-center m-auto gap-10">
          {currentShips.map((ship) => (
            <div
              key={ship.id}
              className="bg-white w-[300px] xm:w-[100%] rounded-lg p-4 shadow hover:shadow-lg transition-shadow"
            >
              <h4 className="text-lg font-semibold mb-2">{ship.vessel_type}</h4>
              <div>
                {(() => {
                  let imageUrl = null;
                  const images = allImagesReg.filter((img) => img.ships === ship.id);
                  imageUrl = images[0]?.image || "https://via.placeholder.com/300x150?text=No+Image";

                  return (
                    <img
                      src={(allImagesReg.find((img) => img.ships === ship.id)?.image) || Logo}
                      className="w-full rounded-lg cursor-pointer h-[110px]"
                      alt="Ship"
                    />
                  );
                })()}
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        {totalPages >=0  && (
          <div className="flex justify-center items-center mt-6 space-x-4">
            <button
              onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className={`px-3 py-1 rounded ${
                currentPage === 1 ? "bg-gray-300 cursor-not-allowed" : "bg-[#d1a460] text-white"
              }`}
            >
              <i className='fa-solid fa-chevron-left'></i>
            </button>

            <div className="px-5 py-1 rounded bg-[#d1a460] text-white font-semibold select-none">
              {currentPage}
            </div>

            <button
              onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
              className={`px-3 py-1 rounded ${
                currentPage === totalPages ? "bg-gray-300 cursor-not-allowed" : "bg-[#d1a460] text-white"
              }`}
            >
              <i className='fa-solid fa-chevron-right'></i>

            </button>
          </div>
        )}
      </>
    ) : (
      <p className="text-gray-600 text-center">
        You haven't registered any ships yet.
      </p>
    )}
  </div>
)}


      {activeTab === "charters" && (
        <div className="mt-14 text-[#253356]">
    {myCharters.length > 0 ? (
      <>
        <div className="grid grid-cols-4 2xl:flex ssm:flex-wrap ssm:justify-center m-auto gap-10">
          {currentCharters.map((ship) => (
            <div
              key={ship.id}
              className="bg-white w-[300px]  xm:w-[100%]  rounded-lg p-4 shadow hover:shadow-lg transition-shadow"
            >
              <h4 className="text-lg font-semibold mb-2">{ship.vessel_type}</h4>
              <div>
                {(() => {
                  let imageUrl = null;
                  const images = charterImg.filter((img) => img.charter === ship.id);
                  imageUrl = images[0]?.image || "https://via.placeholder.com/300x150?text=No+Image";

                  return (
                    <img
                      src={(charterImg.find((img) => img.charter === ship.id)?.image) || Logo}
                      className="w-full rounded-lg cursor-pointer h-[110px]"
                      alt="Ship"
                    />
                  );
                })()}
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        {totalPages >=0  && (
          <div className="flex justify-center items-center mt-6 space-x-4">
            <button
              onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className={`px-3 py-1 rounded ${
                currentPage === 1 ? "bg-gray-300 cursor-not-allowed" : "bg-[#d1a460] text-white"
              }`}
            >
              <i className='fa-solid fa-chevron-left'></i>
            </button>

            <div className="px-5 py-1 rounded bg-[#d1a460] text-white font-semibold select-none">
              {currentPage}
            </div>

            <button
              onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
              className={`px-3 py-1 rounded ${
                currentPage === totalPages ? "bg-gray-300 cursor-not-allowed" : "bg-[#d1a460] text-white"
              }`}
            >
              <i className='fa-solid fa-chevron-right'></i>

            </button>
          </div>
        )}
      </>
    ) : (
      <p className="text-gray-600 text-center">
        You haven't registered any ships yet.
      </p>
    )}
  </div>
      )}

      {activeTab === "logistics" && (
        <div className="mt-8 text-[#253356] text-center">
          <p>Show registered logistics here...</p>
        </div>
      )}

      {activeTab === "equipments" && (
        <div className="mt-8 text-[#253356] text-center">
          <p>Show registered equipments here...</p>
        </div>
      )}
    </div>

      </div>
    </div>
  )
}
